import { closest } from '@ardoq/common-helpers';

export const getTarget = (el: EventTarget | null) =>
  closest(el, `[data-global-handler-id]`);
